import { render, staticRenderFns } from "./CustomizeAppToken.vue?vue&type=template&id=852795fe&scoped=true&"
import script from "./CustomizeAppToken.vue?vue&type=script&lang=js&"
export * from "./CustomizeAppToken.vue?vue&type=script&lang=js&"
import style0 from "./CustomizeAppToken.vue?vue&type=style&index=0&id=852795fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "852795fe",
  null
  
)

export default component.exports